import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ReportFilesService } from '../service/report-files.service';

export const reportFilesResolver: ResolveFn<any> = (route, state) => {
  return inject(ReportFilesService).getReportFiles('Facility');
};
